module.exports = __webpack_public_path__ + "static/media/logo.5620ed5b.png";